import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBStudentEmploymentType = Database["public"]["Enums"]["student_employment_type"];

export const StudentEmploymentType = {
	FULL_TIME: "full_time",
	PART_TIME: "part_time",
	INTERNSHIP: "internship",
	SELF_EMPLOYED: "self_employed",
	UNEMPLOYED: "unemployed",
} as const satisfies Record<string, DBStudentEmploymentType>;

export type StudentEmploymentType = (typeof StudentEmploymentType)[keyof typeof StudentEmploymentType];

type _EnsureAllDBValues = Exclude<DBStudentEmploymentType, StudentEmploymentType> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const STUDENT_EMPLOYMENT_TYPES = Object.values(StudentEmploymentType) as readonly StudentEmploymentType[];

export const studentEmploymentTypeSchema = z.enum(StudentEmploymentType);

export const STUDENT_EMPLOYMENT_TYPE_LABELS: Record<StudentEmploymentType, string> = {
	full_time: "Full-time",
	part_time: "Part-time",
	internship: "Internship",
	self_employed: "Self-employed",
	unemployed: "Unemployed",
};
